import TableOnly from "components/DataTable/TableOnly";
import RefreshButton from "components/RefreshButton/RefreshButton";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import QuoteAdvanceFormLayout from "./AdvanceSearch/QuoteAdvanceFormLayout";
import QuoteAdd from "./QuoteAdd";
import QuoteQuickView from "./QuoteQuickView";

function Quote() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.userInfo);
  const [searchParams, setSearchParams] = useSearchParams();

  const params = useParams();
  const navigate = useNavigate();

  /*   All States
   ********************************************* */
  const [quote, setQuote] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);

  const [showQuickView, setShowQuickView] = useState(false);

  const [advanceSearchModal, setAdvanceSearchModal] = useState(false);
  // Non-null means a find is active and its results replace the paged list.
  const [searchResult, setSearchResult] = useState(null);

  const [totalPages, setTotalPages] = useState(1);

  const [isLoading, setIsLoading] = useState(null);

  /*   All Functions
   ********************************************* */
  const getQuote = async () => {
    setIsLoading(true);

    try {
      let page = searchParams.get("page");
      let query = searchParams.get("query");

      let activeTab = params?.filterBy || "all";
      let limit = searchParams.get("limit") || 10;

      let body = { page, activeTab, limit };

      if (query) {
        body.query = query;
      }

      // check for sort and order in searchParams
      let sort = searchParams.get("sort");
      let order = searchParams.get("order");
      if (sort && order) {
        body.sort = sort;
        body.order = order;
      }

      const { data } = await API.post("/quotes", body, {
        headers: authHeader(),
      });

      setQuote(data.result);
      setTotalPages(data.pages);
      setIsLoading(false);
      return data.result;
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
      setIsLoading(false);
    }
  };

  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      newParams.set("page", "1");
      return newParams.toString();
    });
  };

  const updateSearchParams = (key, value) => {
    if (key && value) {
      setSearchParams((prev) => {
        return {
          ...prev,
          [key]: value,
        };
      });
    }
    if (key && !value) {
      setSearchParams((prev) => {
        const newParams = { ...prev };
        delete newParams[key];
        return newParams;
      });
    }
  };

  // Example usage of the function

  // Getting 12 Hours Time from SQL timestamp
  const convertSqlTimestampToDate = (sqlTime) => {
    const timestamp = sqlTime;
    const date = new Date(timestamp);
    const time = date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return time;
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);

    return params.toString();
  };

  const handleViewCustomer = (customerId) => {
    navigate(`/customer/details/${customerId}`);
  };

  /*   Table Functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <div className="d-flex justify-content-end align-items-center">
        <button
          onClick={() => setAdvanceSearchModal(true)}
          type="button"
          className="btn btn-info text-white"
        >
          Find
        </button>
        {searchResult && (
          <button
            onClick={() => setSearchResult(null)}
            type="button"
            className="btn btn-outline-danger ms-1 text-nowrap"
          >
            Clear Find
          </button>
        )}
        <RefreshButton
          className="btn btn-outline-primary ms-1"
          onClick={() => getQuote()}
        />
        {(user?.permissions?.includes("quote_add") ||
          user?.roles === "admin") && (
          <button
            onClick={() => setShowAddModal(true)}
            type="button"
            className="btn btn-primary  ms-1"
          >
            Add Quote
          </button>
        )}
        {/* <button onClick={TestFunc} className="btn btn-success ms-1">
            Test Func
          </button> */}
      </div>
    </div>
  );

  const table_head = [
    { name: "Q-ID", value: "quoteId" },
    { name: "Customer Name", value: "customer.customerName" },
    { name: "Job Name", value: "jobName" },
    // { name: "Type", value: "bidId" },
    { name: "Location", value: "location.locationName" },
    { name: "Status", value: "status" },

    { name: "Created Date", value: "createdAt" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="py-1 align-middle me-0">Q-{item?.quoteId}</td>
      <td className="py-1 align-middle me-0 d-flex align-items-center">
        <button
          onClick={() => handleViewCustomer(item?.customer?.customerId)}
          className="btn btn-sm btn-info text-white me-2 py-0"
        >
          View
        </button>
        <div> {item?.customer?.customerName?.slice(0, 30)}</div>
      </td>
      <td className="py-1 align-middle me-0">{item?.jobName?.slice(0, 30)}</td>
      {/* <td className="py-1 align-middle me-0">
        {item?.bidId ? "Bid" : "Quote"}
      </td> */}
      <td className="py-1 align-middle me-0">{item?.location?.locationName}</td>
      <td className="py-1 align-middle me-0">{item?.status}</td>

      <td className="py-1 align-middle me-0">
        {convertSqlTimestampToDate(item.createdAt)}
      </td>

      <td className="table-action d-flex py-1 align-middle me-0">
        {/* <QuotePdfButton btnClasses={"btn btn-success"} selectedQuote={item} /> */}
        <button
          onClick={async () => {
            await updateSearchParams("selected-quote", item?.quoteId);
            setShowQuickView(true);
          }}
          className={`btn btn-sm btn-info text-white mx-1 `}
        >
          Quick View
        </button>
        <button
          onClick={() => {
            navigate(
              `/quotes/details/${params.filterBy ? params?.filterBy : "all"}/${
                item?.quoteId
              }?${searchParams.toString()}`,
            );
          }}
          className={`btn btn-sm bg-success text-white mx-1 `}
        >
          Details
        </button>
      </td>
    </tr>
  );

  /*   All Use Effects
   ********************************************* */

  useEffect(() => {
    if (searchParams.get("selected-quote")) {
      return;
    }

    let timeout = setTimeout(() => {
      let filterBy = params?.filterBy;
      if (filterBy) {
        getQuote();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [params.filterBy, searchParams]);

  return (
    <div className="row">
      {quote ? (
        <div className="col-12">
          <div className="d-flex">
            {/*    Table Card
             ********************************************* */}
            <div className=" flex-grow-1">
              <div
                className={`flex-grow-1 d-none d-flex flex-column bg-white shadow-sm px-5 py-2`}
                style={{
                  position: "fixed",
                  top: 0,
                  width: "calc(100vw - 200px)",
                  marginLeft: 200,
                  zIndex: "99",
                }}
              >
                <ul className="nav nav-tabs nav-bordered border-0 d-flex flex-grow-1">
                  <li
                    onClick={() => {
                      let url = "/quotes/all?page=1";

                      navigate(url);
                    }}
                    className=""
                  >
                    <button
                      className={
                        params.filterBy === "all"
                          ? `btn btn-primary active bg-primary text-white`
                          : "nav-link"
                      }
                    >
                      <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                      <span className="d-none d-md-block">All</span>
                    </button>
                  </li>
                  <li
                    onClick={() => {
                      let url = "/quotes/quotes?page=1";

                      navigate(url);
                    }}
                    className="nav-item"
                  >
                    <button
                      className={
                        params.filterBy === "quotes"
                          ? `btn btn-primary active bg-primary text-white`
                          : "nav-link"
                      }
                    >
                      <span className="d-none d-md-block">Quotes</span>
                    </button>
                  </li>

                  <li
                    onClick={() => {
                      let url = "/quotes/bids?page=1";
                      navigate(url);
                    }}
                    className="nav-item"
                  >
                    <button
                      className={
                        params.filterBy === "bids"
                          ? `btn btn-primary active bg-primary text-white`
                          : "nav-link"
                      }
                    >
                      <span className="d-none d-md-block">Bids</span>
                    </button>
                  </li>
                </ul>
              </div>
              <div className="">
                <>
                  {isLoading && <Spinner />}

                  <div
                    className=" px-3 py-2 pb-2 horizontal-scrollable py-2 d-flex flex-column flex-grow-1"
                    style={{ borderRadius: 10, marginLeft: 260 }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div className="d-flex align-items-center gap-3">
                        <h2 className="">Quotes</h2>
                        <div className="d-flex align-items-center gap-1">
                          <div>Show</div>
                          <button
                            className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {parseInt(searchParams.get("limit")) || 10}
                          </button>
                          <ul
                            style={{ width: "fit-content" }}
                            className="dropdown-menu"
                          >
                            {[5, 10, 15, 20, 50].map((n) => (
                              <li key={n} onClick={() => changeLimit(n)}>
                                <button className="dropdown-item">{n}</button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end align-items-center">
                        <div className="me-1">{btn1()}</div>
                        <SearchComp
                          setLoading={setIsLoading}
                          apiPath={`/quotes/${
                            params.filterBy
                          }?${getSearchParamsWithoutGivenKey("query")}&`}
                        />
                      </div>
                    </div>
                    {searchResult && (
                      <div className="alert alert-info py-1 px-2 mb-2">
                        Showing <strong>{searchResult.length}</strong> find
                        result{searchResult.length === 1 ? "" : "s"}. Use{" "}
                        <strong>Clear Find</strong> to go back to the full list.
                      </div>
                    )}
                    <TableOnly
                      table_head={table_head}
                      table_body={table_body}
                      table_data={searchResult || quote}
                      totalPages={totalPages}
                    />
                    {/* The find returns its whole result set in one response,
                        so paging it against the list's page count would be
                        wrong -- hide the pager while a find is active. */}
                    {!searchResult && (
                      <Pagination
                        totalPages={totalPages}
                        apiPath={`/quotes/${params.filterBy}${
                          searchParams.toString()
                            ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                            : "?"
                        }page=`}
                        currPage={parseInt(searchParams.get("page")) || 1}
                      />
                    )}
                  </div>
                </>
              </div>
            </div>

            {/*   ADD Modal
             ********************************************* */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
              <Modal.Body className="bg-white shadow-lg px-3 py-2 custom-border-radius">
                <div>
                  <QuoteAdd showAddModal={setShowAddModal} />
                </div>
              </Modal.Body>
            </Modal>

            {/*   Build A Find Modal
             ********************************************* */}
            <Modal
              show={advanceSearchModal}
              onHide={() => setAdvanceSearchModal(false)}
              size="xl"
              scrollable
            >
              <Modal.Body className="bg-white shadow-lg px-3 py-2 custom-border-radius">
                <QuoteAdvanceFormLayout
                  showModal={setAdvanceSearchModal}
                  setSearchResult={setSearchResult}
                />
              </Modal.Body>
            </Modal>
          </div>
        </div>
      ) : (
        <Spinner />
      )}
      {/*   Quick View Modal
       ********************************************* */}
      <Modal
        show={showQuickView}
        size="lg"
        onHide={() => {
          setShowQuickView(false);
          updateSearchParams("selected-quote", null);
        }}
        contentClassName="bg-transparent"
      >
        <Modal.Body className="bg-light px-3 custom-border-radius-sm">
          {searchParams?.get("selected-quote") && (
            <QuoteQuickView
              updateSearchParams={updateSearchParams}
              setShowQuickView={setShowQuickView}
              allData={quote}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Quote;
